import React, { useContext } from "react"
import { FaPlay, FaPause } from "react-icons/all"
import { AudioContext } from "../context/audioContext"
import { VideoContext } from "../context/videoContext"

const AudioCard = ({ id, title, src, descr, type }) => {
  const [music, setMusic] = useContext(AudioContext)
  const [video, setVideo] = useContext(VideoContext)
  const songName = title.split("")[0]

  const playAudio = () => {
    setMusic({
      ...music,
      id: id,
      title: title,
      src: src,
      type: type,
      cover: songName,
      currentPlaying: {
        musicId: id,
        isPlaying: music && music.currentPlaying.isPlaying,
      },
    })
    setVideo({
      title: "",
      src: "",
      descr: "",
      type: "",
      currentPlaying: {
        videoId: "",
        isPlaying: false,
      },
    })
  }

  const buyBeat = () => {
    setMusic({
      ...music,
      purchaseId: id,
    })
  }

  return (
    <article className="audio-card">
      <div className="icon-container">
        <button className="play-audio" onClick={playAudio}>
          {music &&
          id === music.currentPlaying.musicId &&
          music.currentPlaying.isPlaying ? (
            <FaPause className="icon" />
          ) : (
            <FaPlay className="icon" />
          )}
        </button>
      </div>
      <div className="name">
        <div className="cd"></div>
        {/* <h2>{songName}</h2> */}
        <h1>{title}</h1>
      </div>
      {/* <div className="cost">
        {"70000Tsh"}
      </div> */}
      <div className="playing-animations">
        {music && id === music.currentPlaying.musicId ? (
          <div className="isPlaying">
            <div
              className={
                music && music.currentPlaying.isPlaying
                  ? "audio-play-animations animated"
                  : "audio-play-animations"
              }
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="btns">
        <button className="play" onClick={playAudio}>
          {music && id === music.currentPlaying.musicId
            ? "Now Playing"
            : "Play"}
        </button>
        <button className="purchase" onClick={buyBeat}>
          Buy
        </button>
      </div>
    </article>
  )
}

export default AudioCard
